import React, { FunctionComponent, JSX, useState } from 'react'
import styles from './selectUniqueIcon.module.scss'
import { Grid, IconButton, Popover } from '@mui/material'

export type SelectUniqueIconOptions = {
    title: string
    icon: JSX.Element
}

interface SelectUniqueIconProps {
    title: string
    icon: JSX.Element
    iconsOptions: SelectUniqueIconOptions[]
    setIcon: (icon: string) => void
    className?: string
}

const SelectUniqueIcon: FunctionComponent<SelectUniqueIconProps> = ({
    title,
    icon,
    iconsOptions,
    setIcon,
    className
}: SelectUniqueIconProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    function handleOpen(event: React.MouseEvent<HTMLElement>): void {
        setAnchorEl(event.currentTarget)
    }

    function handleClosePopover(): void {
        setAnchorEl(null)
    }

    function handleSelectIcon(icon: string): void {
        setIcon(icon)
        handleClosePopover()
    }

    return (
        <>
            <div className={`${styles.IconPickerContainer} ${className}`}>
                <span className={styles.Text}>{title} :</span>
                <IconButton onClick={handleOpen} className={styles.SelectedIcon}>
                    {icon}
                </IconButton>
            </div>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <Grid container spacing={1} padding={2} className={styles.IconGrid}>
                    {iconsOptions.map((iconOption: SelectUniqueIconOptions) => (
                        <Grid itemScope key={iconOption.title}>
                            <IconButton
                                onClick={() => handleSelectIcon(iconOption.title)}
                                className={styles.IconButton}
                            >
                                {iconOption.icon}
                            </IconButton>
                        </Grid>
                    ))}
                </Grid>
            </Popover>
        </>
    )
}

export default SelectUniqueIcon
